import {
  ADD_PERSONAL_INFORMATION_STARTED,
  ADD_PERSONAL_INFORMATION_SUCCESS,
  ADD_PERSONAL_INFORMATION_ENDED,
  ADD_PERSONAL_INFORMATION_ERROR,
} from '../types/personal_info_types';

const initialState = {
  add_personal_info_loading: false,
  add_personal_info_errors: null,
  add_personal_info_success: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case ADD_PERSONAL_INFORMATION_STARTED:
      return {
        ...state,
        add_personal_info_loading: true,
        add_personal_info_errors: null,
        add_personal_info_success: null,
      };
    case ADD_PERSONAL_INFORMATION_ENDED:
      return {
        ...state,
        add_personal_info_loading: false,
      };
    case ADD_PERSONAL_INFORMATION_ERROR:
      return {
        ...state,
        add_personal_info_errors: payload,
      };
    case ADD_PERSONAL_INFORMATION_SUCCESS:
      return {
        ...state,
        add_personal_info_success: payload,
      };

    default:
      return state;
  }
}
